import React, { useContext, useState, useEffect } from "react";
import styles from "../../Styles/Settings.module.css";
import Dashboardheader from "../../components/Dashboardheader";
import UserContext from "../../context/UserContext";
import { toast } from "react-toastify";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Settings() {
  const { user, userInfo } = useContext(UserContext);
  const [fullname, setFullname] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [loading, setLoading] = useState(false);

  // Pre-populate from context when user data is available
  useEffect(() => {
    if (user.fullname) setFullname(user.fullname);
    if (user.phoneNo) setPhoneNo(user.phoneNo);
  }, [user.fullname, user.phoneNo]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fullname.trim() || !phoneNo.toString().trim()) {
      toast.error("Please fill in all fields.", { position: "top-left" });
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/app/auth/user/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify({
          fullname: fullname.trim(),
          phone_no: phoneNo.toString().trim(),
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("Profile updated successfully!", {
          position: "top-left",
        });
        // Refresh user context with updated data
        userInfo();
      } else {
        toast.error(data.message || "Failed to update profile.", {
          position: "top-left",
        });
      }
    } catch (error) {
      console.error("Update profile error:", error);
      toast.error("An error occurred. Please try again.", {
        position: "top-left",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.settings_page}>
      <Dashboardheader
        header={"Settings"}
        subheader={"Update your profile information"}
      />

      <div className={styles.card}>
        <div className={styles.card_header}>
          <h3>Profile Details</h3>
          <p>Update your name and phone number below</p>
        </div>

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.field}>
            <label htmlFor="email">Email</label>
            <div className={styles.email_display}>{user.email}</div>
          </div>

          <div className={styles.field}>
            <label htmlFor="fullname">Full Name</label>
            <input
              id="fullname"
              type="text"
              value={fullname}
              onChange={(e) => setFullname(e.target.value)}
              placeholder="Enter your full name"
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="phoneNo">Phone Number</label>
            <input
              id="phoneNo"
              type="text"
              value={phoneNo}
              onChange={(e) => setPhoneNo(e.target.value)}
              placeholder="Enter your phone number"
            />
          </div>

          <button
            type="submit"
            className={styles.submit_btn}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Settings;
